window.addEventListener("error", function (e) {
  if (e.message.includes("removeChild")) {
    e.preventDefault();
    return;
  }
});

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import i18n from "i18next";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { initReactI18next } from "react-i18next";
import { TahunProvider } from "./contexts/TahunContext.tsx";
import { UserProvider } from "./contexts/UserContext.tsx";
import "./index.css";
import { translationEn } from "./locales/en.ts";
import { translationId } from "./locales/id.ts";
import AppRouter from "./routes/index.tsx";

export const queryClient = new QueryClient();

i18n.use(initReactI18next).init({
  resources: {
    id: {
      translation: translationId,
    },
    en: {
      translation: translationEn,
    },
  },
  lng: localStorage.getItem("lang") || "id",
  fallbackLng: "id",
  interpolation: {
    escapeValue: false,
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <TahunProvider>
          <AppRouter />
        </TahunProvider>
      </UserProvider>
      <Toaster position="bottom-center" toastOptions={{ duration: 5000 }} />
    </QueryClientProvider>
  </StrictMode>,
);
